import React from 'react'
import parse from 'inline-style-parser'

/*
P then Q simplified
props.showButton     props.showButton()     button is shown
       t                    t                     t
       t                    f                     f
       f                    t                     t
       f                    f                     t
!(props.showbutton && !props.showbutton())
*/
export function ActionCenterEntry(props) {
    return (
        <div class="action-center-row">
            <div className="action-center-title">
                <label class="action-center-label">{props.title}</label>
                <h5 class="action-center-label title action-center-item-text">{props.description}</h5>
            </div>
            <span class="action-center-spacer"/>
            <div style={{paddingTop:"10px"}}>
                {props.buttonOverride ? (
                    props.buttonOverride
                ) : (
                    !props.hideButton && (
                        <button
                            type="button"
                            data-loading-text="Loading..."
                            class={"action-center-button btn " + (props.danger ? ("btn-danger") : ("btn-secondary")) + " btn-info btn-fill"}
                            disabled={props.disabled}
                            autoComplete="off"
                            onClick={props.buttonCallback}
                        >
                            {props.buttonText}
                        </button>
                    )
                )}
                {props.modal && (props.modal)}
            </div>
        </div>
    )
}

export default class ActionCenterCard extends React.Component {
    render() {
        return (
            <div class="card">
                <div class="header col-md-12 col-sm-12 col-xs-12">
                    <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-hand-action"></i></span> Action Center</h4>
                </div>
                <div class="content">
                    { this.props.children }
               </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// app/helpers/Cards/ActionCenter.jsx